import { Alert, Button, CircularProgress, FormControl, FormHelperText, Grid, IconButton, Input, InputAdornment, InputLabel, Snackbar, Typography } from "@mui/material";
import { useAuthContext } from "../contexts/AuthContext";
import { useState } from "react";
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { AccountBoxRounded, LockRounded, Visibility } from "@mui/icons-material";
import { UserAuthRequest, UserAuthResponse } from "../types/types";
import { useNavigate } from "react-router-dom";
import { getApiUrlFromStorage, setTokenInStorage } from "../helpers/helpers";

const SignIn = () => {

  const { updateContext } = useAuthContext();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [authError, setAuthError] = useState(false);

  const apiUrl = getApiUrlFromStorage();

  const navigate = useNavigate();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e: React.MouseEvent) => {
    e.preventDefault();
    setEmailError(false);
    setPasswordError(false);

    if (email.length === 0) {
      setEmailError(true);
    }
    if (password.length === 0) {
      setPasswordError(true);
    }
    if (emailError || passwordError) {
      return;
    }

    login({
      identifier: email,
      password: password,
    });

  }

  const login = (userAuthRequest: UserAuthRequest) => {
    setIsLoading(true);

    fetch(`${apiUrl}/auth/local`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify(userAuthRequest),
    })
      .then(res => {
        if (!res.ok) {
          throw Error(`Unable to login. Status: ${res.status} - ${res.statusText}`);
        }
        return res.json();
      })
      .then((data: UserAuthResponse) => {
        setTokenInStorage(data.jwt);
        updateContext();
        navigate('/activity-list');
      })
      .catch((err) => {
        // catches network errors + http not OK errors
        console.log(err);
        setAuthError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '100vh' }}
    >
      <form noValidate>
        <Typography variant="h4" sx={{ m: 1 }}>Welcome to Time Tracker</Typography>
        <div>
          <FormControl error={emailError} variant="standard" sx={{ m: 1, width: '30ch' }}>
            <InputLabel htmlFor="email">Email</InputLabel>
            <Input
              onChange={(e) => setEmail(e.target.value)}
              id="email"
              startAdornment={
                <InputAdornment position="start">
                  <AccountBoxRounded />
                </InputAdornment>
              }
            />
            <FormHelperText>{emailError ? 'Please enter your email' : ''}</FormHelperText>
          </FormControl>
        </div>
        <div>
          <FormControl error={passwordError} sx={{ m: 1, width: '30ch' }} variant="standard">
            <InputLabel htmlFor="password">Password</InputLabel>
            <Input
              id="password"
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword ? 'text' : 'password'}
              startAdornment={
                <InputAdornment position="start">
                  <LockRounded />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
            <FormHelperText>{passwordError ? 'Please enter a password' : ''}</FormHelperText>
          </FormControl>
        </div>
        <div>
          {
            isLoading ? <CircularProgress /> : <Button sx={{ ml: 1, mt: 2 }} variant="contained" onClick={handleLogin}>Login</Button>
          }
        </div>
        {
          authError ?
            (<Snackbar open={authError} autoHideDuration={5000} onClose={() => { setAuthError(false) }}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
              <Alert onClose={() => { setAuthError(false) }} severity="error" sx={{ width: '100%' }}>
                Incorrect email / password
              </Alert>
            </Snackbar>) : <></>
        }
      </form>
    </Grid>
  );
}

export default SignIn; 